module.exports = __webpack_public_path__ + "media/images/flags/sz-f2cba9b21cb0aa244085d8b5be63bc0d.svg";